export default {"src":"/_next/static/media/product-slider-right-arrow.cfc5bfd4.svg","height":14,"width":18,"blurWidth":0,"blurHeight":0};